module.exports = __webpack_public_path__ + "9e745687ae228c1210dc6c23b03799d8.png";